import { NgxCurrencyDirective } from 'ngx-currency';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CurrencyInputComponent } from '@mitsubishi/shared/ui';
import { PriceComponent } from '@mitsubishi/ui/pricing';

import { ApmProjectCurrencyPipe } from '../pipes/apm-project-currency.pipe';
import { AccessoryPriceComponent } from './accessory-price.component';

@NgModule({
  declarations: [AccessoryPriceComponent],
  imports: [
    CommonModule,

    FormsModule,
    ApmProjectCurrencyPipe,
    NgxCurrencyDirective,
    CurrencyInputComponent,
    PriceComponent,
  ],
  exports: [AccessoryPriceComponent],
})
export class AccessoryPriceModule {}
